import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";


export default function useGetAllReturnWorkflowExecutions(shopId: string, workflowId: string) {
	return $api.useQuery("get", "/shops/{shopId}/return-workflows/{workflowId}/executions", {
		params: { path: { shopId, workflowId } },
	});
}

export function useInvalidateAllReturnWorkflowExecutions() {
	const client = useQueryClient();
	return (shopId: string, workflowId: string) => {
		client.invalidateQueries({
			queryKey: [
				"get",
				"/shops/{shopId}/return-workflows/{workflowId}/executions",
				{ params: { path: { shopId, workflowId } } },
			],
		});
	};
}
